<template lang="pug">
	.boutiques-page
		Breadcrumbs(:breadcrumbsList="breadcrumbsList")

		.boutiques-page__content
			h1.inner-title {{ page.title.rendered }}

			.boutiques-page__row

				.boutiques-page__col(v-for="(city, index) in page.acf.cities" :key="index")
					.boutiques-block
						h2.boutiques-block__title  {{ city.title }}

						.boutiques-block__links
							.link(v-for="(address, index) in city.addresses_list"
										:key="index")
								a(v-if="address.link != ''"
									:href="address.link + '/'"
									target="_blank") {{ address.name }}
								span(v-else) {{ address.name }}
</template>

<script>
import api from '@/api/index'
import Breadcrumbs from '@/components/partials/Breadcrumbs'

export default {
  components: { Breadcrumbs },

  data() {
    return {
      page: {},

      breadcrumbsList: [
        {
          link: this.localePath('index'),
          name: this.$t('breadcrumbs.home')
        },
        {
          link: this.$route.path,
          name: ''
        }
      ]
    }
  },

  head() {
		let breadcrumbsMarkup = {
			"@context": "https://schema.org",
			"@type": "BreadcrumbList",
				"itemListElement": [{
					"@type": "ListItem",
					"position": 1,
					"name": this.$t('breadcrumbs.home'),
					"item": 'https://sitelle.ua' + this.localePath('index')
				},{
					"@type": "ListItem",
					"position": 2,
					"name": this.page.title.rendered,
					"item": 'https://sitelle.ua' + this.$route.path
				}]
		}

    return {
      title: this.pageTitle,
      titleTemplate: null,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.metaDescr
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.pageTitle
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.metaDescr
        }
			],
			script: [
				{
					type: 'application/ld+json',
					innerHTML: JSON.stringify(breadcrumbsMarkup)
				}
			]
    }
  },

  computed: {
    pageTitle() {
      return this.page.yoast_meta.yoast_wpseo_title
    },

    metaDescr() {
      return this.page.yoast_meta.yoast_wpseo_metadesc
    }
  },

  async asyncData({ store }) {
    const data = await api.getBoutiquesPage(store.state.geoData.locale)

    return { page: data }
  },

  created() {
    this.breadcrumbsList[1].name = this.page.title.rendered
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/helpers/vars';
@import '~assets/scss/helpers/mixins';

.boutiques-page {
  padding: 20px 0 375px;

  @include laptop {
    padding-bottom: 150px;
  }

  @include tablet {
    padding-bottom: 100px;
  }

  @include mobile {
    padding: 25px 0 40px;
  }

  &__content {
    margin-top: 20px;
    letter-spacing: -0.3px;

    @include mobile {
      margin-top: 0;
    }
  }

  &__row {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    margin: 20px -20px 0;

    @include laptop {
      margin-left: -15px;
      margin-right: -15px;
    }

    @include mobile {
      margin: 25px 0 0;
    }
  }

  &__col {
    flex: 0 0 100%;
    max-width: 50%;
    margin-bottom: 25px;
    padding-left: 20px;
    padding-right: 20px;

    @include laptop {
      padding-left: 15px;
      padding-right: 15px;
    }

    @include mobile {
      max-width: 100%;
      padding: 0;
      margin-bottom: 20px;
    }
  }
}

.boutiques-block {
  &__title {
    margin-bottom: 5px;
    font-size: 28px;
    font-weight: 500;
    line-height: 1.45;

    @include mobile {
      font-size: 20px;
    }
  }

  &__links {
    a,
		span {
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 0.5px;
      line-height: 1.5;
      transition: color 0.3s;

      @include mobile {
        font-size: 14px;
      }
    }
		a:hover {
			color: rgba($blackColor, 0.5);
		}
  }
}
</style>
